import {
  AssetRoutineState,
  FeatureName,
  RoutineState,
  useIsFeatureEnabled,
  WorkflowPageConfig,
  WorkflowQuestionConfig,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { useEffect, useMemo, useState } from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { tokens } from '../../../crop-circle/tokens';
import { useFormContext } from '../../../forms';
import { styles, stylesCropCircle } from './styles';
import { WorkflowExecutionQuestion } from './workflowExecutionQuestion';

type WorkflowExecutionPageProps = {
  page: WorkflowPageConfig;
  workspaceAsset: WorkspaceAsset;
  toggleProcessing?: (value: boolean) => void;
  currentState: AssetRoutineState<RoutineState> | undefined;
  isIssueEditRoutine?: boolean;
};

interface QuestionResponse {
  index: number;
  config: WorkflowQuestionConfig;
}

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const WorkflowExecutionPageOld = (props: WorkflowExecutionPageProps) => {
  const [initialized, setInitialized] = useState(false);
  const [questionResponses, setQuestionResponses] = useState<
    QuestionResponse[]
  >([]);

  const { getValues } = useFormContext();
  const fields = getValues('responses');

  useEffect(() => {
    const responses: QuestionResponse[] = [];
    props.page.questions
      .sort((a, b) => a.order - b.order)
      .forEach((question) => {
        const index = fields.findIndex(
          (field: any) => field.questionId === question.id
        );
        responses.push({ index, config: question });
      });
    setQuestionResponses(responses);

    setInitialized(true);
  }, []);

  return (
    initialized && (
      <>
        {props.page.instructions && (
          <View style={styles.instructionsContainer}>
            <Text style={styles.instructionsText}>
              {props.page.instructions}
            </Text>
          </View>
        )}
        {questionResponses.map((response, index) => (
          <WorkflowExecutionQuestion
            key={`question_${index}`}
            config={response.config}
            questionIndex={index}
            responseIndex={response.index}
            workspaceAsset={props.workspaceAsset}
            toggleProcessing={props.toggleProcessing}
            currentState={props.currentState}
            isIssueEditRoutine={props.isIssueEditRoutine}
          />
        ))}
      </>
    )
  );
};

// TODO: Crop Circle Redesign | Remove to WorkflowExecutionPageBase after feature is fully rolled out
const WorkflowExecutionPageBase = (props: WorkflowExecutionPageProps) => {
  const { getValues } = useFormContext();
  const fields = getValues('responses');

  const questionResponses = useMemo<QuestionResponse[]>(
    () =>
      [...props.page.questions]
        .sort((a, b) => a.order - b.order)
        .map((question) => ({
          index: fields.findIndex(
            (field: any) => field.questionId === question.id
          ),
          config: question,
        })),
    [props.page.questions, fields]
  );

  return (
    <>
      {props.page.instructions && (
        <View style={stylesCropCircle.instructionsContainer}>
          <Text style={tokens.typography.body.mediumEmphasised}>
            {props.page.instructions}
          </Text>
        </View>
      )}
      {questionResponses.map((response, index) => (
        <WorkflowExecutionQuestion
          key={`question_${index}`}
          config={response.config}
          questionIndex={index}
          responseIndex={response.index}
          workspaceAsset={props.workspaceAsset}
          toggleProcessing={props.toggleProcessing}
          currentState={props.currentState}
          isIssueEditRoutine={props.isIssueEditRoutine}
        />
      ))}
    </>
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const WorkflowExecutionPage = (props: WorkflowExecutionPageProps) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <WorkflowExecutionPageOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to WorkflowExecutionPageBase after feature is fully rolled out
  return <WorkflowExecutionPageBase {...props} />;
};
